import { z } from "zod";

export const ReportAgentFilterSchemaV4 = z.object({
    property_id: z.string(), 
    base_on: z.enum(["stay_date", "created_reservation"]), // Tipe spesifik untuk base_on
    start_date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/), 
    end_date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
});

export type ReportAgentFilterV4Type = z.infer<typeof ReportAgentFilterSchemaV4>;